/*eslint-disable*/

import { PDFDocument } from "pdf-lib";
import download from "downloadjs";

export const bmPDF = async (formURL, data, additionalData, companyLogo) => {

  const formPdfBytes = await fetch(formURL).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(formPdfBytes);
  const form = pdfDoc.getForm();

  try {
    const fields = form.getFields();
    fields.forEach((field) => {
      const name = field.getName();
      // populate chart data
      for (const obj of data) {
        for (const [key, value] of Object.entries(obj)) {
          if (name === key && value !== "") {
            const bmFields = form.getTextField(name);
            bmFields.setText(value);
          }
        }
      }
      //populate pdf BM info
      for (const [key, value] of Object.entries(additionalData)) {
        if (name === key && value !== "") {
          const bmFields = form.getTextField(name);
          bmFields.setText(value);
        }
      }
    });

    const embedImage = async (imageUrl, fieldName) => {
      const SUPPORTED_FORMATS = {
        jpg: 'embedJpg',
        jpeg: 'embedJpg',
        png: 'embedPng'
      };
    
      const getImageFormat = (url, contentType) => {
        const extension = url.split('.').pop().toLowerCase();
        if (SUPPORTED_FORMATS[extension]) {
          return SUPPORTED_FORMATS[extension];
        }
    
        if (contentType === 'image/jpeg') return 'embedJpg';
        if (contentType === 'image/png') return 'embedPng';
        
        throw new Error('Unsupported image format');
      };
    
      try {
        const response = await fetch(imageUrl);

        const contentType = response.headers.get('Content-Type');
        const imageBytes = await response.arrayBuffer();
    
        const embedMethod = getImageFormat(imageUrl, contentType);
        const image = await pdfDoc[embedMethod](imageBytes);
    
        const imageField = form.getButton(fieldName);
        if (imageField) {
          imageField.setImage(image);
        }
      } catch (error) {
        console.error(`Error embedding image in field ${fieldName}:`, error);
      }
    };

    await embedImage(companyLogo, "logo");

  } catch (error) {
    console.error(error);
  }

  const pdfBytes = await pdfDoc.save();
  return download(pdfBytes, "bm-report.pdf", "application/pdf");
};
